import React from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { Box, Divider, Typography } from "@mui/material";
import DetailBlock from "./DetailBlock";

function OrderSenderInfo() {
  const { t } = useTranslation();
  const { order, loading } = useOutletContext();

  return (
    <>
      <Box className={"flex items-center justify-start mx-4"}>
        <Typography className={"p-2 font-bold smMax:pb-0"}>
          {t("orderTracking.sender")}
        </Typography>
      </Box>
      <Divider orientation={"horizontal"} flexItem className={"smMax:hidden"} />
      <Box className={"flex flex-col mx-4 p-1.5"}>
        <Box className={"flex items-start justify-stretch w-full smMax:flex-wrap"}>
          <DetailBlock
            text={order.senderEmail}
            title={t("accountPage.title")}
            className={"my-2 md:w-1/3 w-full"}
          />
          <Box className={"my-2 w-1/3 smMax:hidden"}>
            <Typography variant="caption" className={"text-gray-500"}>
              {t("orderTracking.phoneNumber")}
            </Typography>
            <Typography>{order.senderPhone}</Typography>
          </Box>
          <Box className={"my-2 w-1/3 smMax:hidden"}></Box>
        </Box>
        <Box className={"flex items-center justify-stretch w-full smMax:flex-wrap"}>
          <DetailBlock
            text={order.senderCompanyName}
            title={t("orderTracking.company")}
            className={"my-2 md:w-1/3 w-full"}
          />
          <Box className={"my-2 smMax:w-1/2 md:hidden"}>
            <Typography variant="caption" className={"text-gray-500"}>
              {t("orderTracking.phoneNumber")}
            </Typography>
            <Typography>{order.senderPhone}</Typography>
          </Box>
          <DetailBlock
            text={order.senderGovNumber}
            title={t("orderTracking.companyID")}
            className={"my-2 md:w-1/3 w-1/2"}
          />
          <Box className={"my-2 w-1/3 smMax:hidden"}></Box>
        </Box>
      </Box>
    </>
  );
}

export default OrderSenderInfo;
